export class HolidayOption {
	name: string;

	constructor(name: string) {
		this.name = name;
	}
}
